import { render, staticRenderFns } from "./complainList.vue?vue&type=template&id=dc78c688&scoped=true"
import script from "./complainList.vue?vue&type=script&lang=js"
export * from "./complainList.vue?vue&type=script&lang=js"
import style0 from "./complainList.vue?vue&type=style&index=0&id=dc78c688&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc78c688",
  null
  
)

export default component.exports